"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = require("react");

var _reactHooks = require("@sprinx/react-hooks");

var _translate = _interopRequireDefault(require("@sprinx/translate"));

var _ApiCallContext = _interopRequireDefault(require("../ApiCallProvider/ApiCallContext"));

var _useClient = _interopRequireDefault(require("../useClient"));

var meanings = {
  none: ['none', null],
  create: ['success', 'app/messages/createdSuccess'],
  update: ['success', 'app/messages/savedSuccess'],
  remove: ['warning', 'app/messages/deletedSuccess']
};

var normalizeMeaning = function normalizeMeaning(m) {
  return meanings[m] || meanings.none;
};
/**
 * Genericka implementace volani API sluzeb.
 *
 * @param {Object} [options] Nastaveni volani
 *
 * @param {string} [options.clientCode='api'] string identifikujici pouziteho clienta. Client je definovan pomoci
 *       rodiny provideru spojeni `ConnectServer`.
 *
 * @param {any} [options.defaultResult] Inicialni data pro bezpecnou inicializaci vysledku. Pred aplikaci `defaultResut`
 *       ma prednost `initialResult`. `defautResult` nezpusobi zastaveni volani dotazu.
 *
 * @param {Array} [options.initialArgs] pokud !== `undefined` zavola se `action` okamzite po namontovani komponenty.
 *       V opacnem pripade se ceka na manualni zavolani akce
 *
 * @param {*} [options.initialResult] inicilani hodnota vysledku. Pokud je definovana hodnota nastavi se jako `result`
 *       a zaroven bude nastaven `loadin === false` => data se nebudou nahravat. Tento bypass je urcen primarne pro
 *       `get` a `list` metody s cached daty.
 *
 * @param {'none' | 'success' | 'warning' | 'error'} [options.meaning='none'] identifikuje vyznam akce. Dle vyznamu je
 *       nastaveno napriklad podbarveni toastu.
 *
 * @param {boolean} [options.returnOnlyAction=false] pokud je `true` vysledkem je samotna akce
 *
 * @param {(client, ...callArgs) => Promise} action Implementace akce.
 *
 *
 * @returns `(...args) => Promise | [result, error, loading, (...args) => Promis]`, pokud je `returnOnlyAction === true`
 *   vraci samotnou akci. V opacnem pripade vraci `tuple` s:
 *     - `result` - vysledkem volani sluzby. Default `undefined`.
 *     - `error` - chyba po volani sluzby. Default `null`.
 *     - `loading` - indikator loadovani, ktery je v prubehu loadovani `true`. Default `true`
 */


function useServiceCall(options, action) {
  var _clientCode$meaning$r = (0, _extends2.default)({
    clientCode: 'api',
    meaning: 'none',
    returnOnlyAction: false
  }, options),
      clientCode = _clientCode$meaning$r.clientCode,
      defaultResult = _clientCode$meaning$r.defaultResult,
      initialArgs = _clientCode$meaning$r.initialArgs,
      initialResult = _clientCode$meaning$r.initialResult,
      meaning = _clientCode$meaning$r.meaning,
      returnOnlyAction = _clientCode$meaning$r.returnOnlyAction;

  var cancellablePromise = (0, _reactHooks.useCancellablePromise)();

  var _ref = (0, _react.useContext)(_ApiCallContext.default) || {
    // eslint-disable-next-line no-console
    showMessage: function showMessage(message) {
      return console.log('API CALL MESSAGE', message);
    }
  },
      showMessage = _ref.showMessage;

  var _normalizeMeaning = normalizeMeaning(meaning),
      _normalizeMeaning2 = (0, _slicedToArray2.default)(_normalizeMeaning, 2),
      smVariant = _normalizeMeaning2[0],
      smMessagePath = _normalizeMeaning2[1];

  var client = (0, _useClient.default)(clientCode);

  var _useState = (0, _react.useState)({
    result: initialResult || defaultResult,
    error: null,
    loading: initialResult === undefined
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      _useState2$ = _useState2[0],
      error = _useState2$.error,
      loading = _useState2$.loading,
      result = _useState2$.result,
      setState = _useState2[1];

  var call = (0, _react.useCallback)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var e,
        r,
        _len,
        args,
        _key,
        _args = arguments;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (client) {
              _context.next = 6;
              break;
            }

            e = new Error("API Server '".concat(clientCode, "' not available"));

            if (!returnOnlyAction) {
              _context.next = 4;
              break;
            }

            throw e;

          case 4:
            setState({
              result: undefined,
              error: e,
              loading: false
            });
            return _context.abrupt("return", undefined);

          case 6:
            _context.prev = 6;

            for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = _args[_key];
            }

            _context.next = 10;
            return cancellablePromise(action.apply(void 0, [client].concat(args)));

          case 10:
            r = _context.sent;
            setState({
              result: r,
              error: null,
              loading: false
            });
            if (smMessagePath) showMessage((0, _translate.default)(smMessagePath), {
              variant: smVariant
            });
            _context.next = 21;
            break;

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](6);
            setState({
              result: undefined,
              error: _context.t0,
              loading: false
            }); // TODO: doimplementovat zbieranie chyb do log API
            // if (process.env.NODE_ENV !== 'production') {

            console.error('`useServiceCall` error:', _context.t0, action); // eslint-disable-line no-console
            // }

            if (!returnOnlyAction) {
              _context.next = 21;
              break;
            }

            throw _context.t0;

          case 21:
            return _context.abrupt("return", r);

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 15]]);
  })), [] // eslint-disable-line react-hooks/exhaustive-deps
  );
  (0, _react.useEffect)(function () {
    if (Array.isArray(initialArgs)) call.apply(void 0, (0, _toConsumableArray2.default)(initialArgs));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  (0, _react.useEffect)(function () {
    if (error) {
      showMessage((0, _translate.default)('app/messages/errorOccurred'), {
        variant: 'error'
      });
    }
  }, [error, showMessage]);
  return returnOnlyAction ? call : [result, error, loading, call];
}

var _default = useServiceCall;
exports.default = _default;